module.exports = __webpack_public_path__ + "img/manual.0c7c3c11.svg";